import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import { useStyles } from './css';
import { HeroUnit } from '../../../components/HeroUnit/HeroUnit';
import { ActionContainer } from '../../../components/ActionContainer/ActionContainer';

export function DeveloperHome() {
    const classes = useStyles();

    return (
        <React.Fragment>
            <HeroUnit
                title={
                    <>
                        Integrate with Bókun <br />
                        and grow your business.
                    </>
                }
                subTitle={
                    'Build apps for thousands of businesses globally - or, just for your own\n' +
                    '                        team.'
                }
            >
                <div className={classes.heroButtons}>
                    <Grid container spacing={2} justify="center">
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                href="https://bokun.dev"
                                target="_blank"
                            >
                                Explore the docs
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                to="/"
                                variant="outlined"
                                color="primary"
                                component={RouterLink}
                            >
                                See the App Store
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </HeroUnit>

            <ActionContainer
                title={'Create a free developer account'}
                message={<>Get started building right away.</>}
                button={{
                    linkTo: '/developer/signup',
                    text: 'Sign up',
                }}
            />
        </React.Fragment>
    );
}
